import { createUseStyles } from 'react-jss'
import { colors } from '#base/js/variables.style'

export const style = {
  sunburstContainer: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  compressedStyles: {
    '& $total': {
      top: 6,
      width: 'auto'
    },
    '& $totalLabel': {
      fontSize: 14
    },
    '& $totalValue': {
      fontSize: 24
    }
  },
  svg: {
    display: 'block'
  },
  arc: {
    stroke: colors.backgroundGray,
    strokeWidth: 1
  },
  emptyArc: {
    extend: 'arc',
    fill: colors.backgroundGray,
    stroke: 'white'
  },
  selectedArc: {
    extend: 'arc',
    opacity: 0.7
  },
  total: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '100%',
    pointerEvents: 'none',
    textTransform: 'uppercase'
  },
  totalLabel: {
    fontSize: 16
  },
  totalValue: {
    fontSize: 28,
    fontWeight: 'bold'
  },
  pathContainer: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  path: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 4,
    width: 180,
    padding: '10px 20px',
    fontSize: 16,
    backgroundColor: 'white',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12)'
  },
  pathLabel: {
    textTransform: 'uppercase',
    fontSize: 17,
    marginBottom: 14,
    textAlign: 'center'
  },
  pathValue: {
    fontSize: 14
  },
  pathArrow: {
    lineHeight: '14px'
  },
  legendKeyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: 14
  },
  legendKey: {
    display: 'flex'
  }
}

export const useStyles = createUseStyles(style)
